<template>
  <div class="fake">
    <bonus-progress
      class="fake_progress"
      v-bind="progressData"
      @open-dialog="openDialog"/>
    <div
      v-if="dialog.visible"
      class="flex items-center fullscreen fake_dialog">
      <bonus-dialog-register
        @handle-continue-watch="handleContinueWatch"
        @close-dialog="closeDialog"/>
    </div>
    <count-time
      v-if="progressData.timer"
      :transform="(time) => Math.floor(time / 1000)"
      @tick="handleBonusTimer"></count-time>
  </div>
</template>

<script>
import BonusProgress from './components/BonusProgress'
import BonusDialogRegister from './components/BonusDialogRegister'
import CountTime from '@/components/CountTime.js'
export default {
  name: 'Fake',
  components: {
    BonusProgress,
    BonusDialogRegister,
    CountTime
  },
  props: {
    player: {
      type: Object,
      default: null
    },
    playingEvent: {
      type: Function,
      default: () => {
        return () => { }
      }
    },
    pauseEvent: {
      type: Function,
      default: () => {
        return () => { }
      }
    }
  },
  data () {
    return {
      dialog: {
        visible: false
      },
      progressData: {
        status: 'FAKE',
        timer: false,
        progress: 0,
        amount: 999
      }
    }
  },
  mounted () {
    this.hijackPlaying()
    this.hijackPasue()
  },
  methods: {
    handleContinueWatch () {
      this.dialog.visible = false
      this.player.play()
    },
    openDialog () {
      this.player.pause()
      this.dialog.visible = true
    },
    closeDialog () {
      this.dialog.visible = false
    },
    handleBonusTimer () {
      this.handleProgressData({ progress: this.progressData.progress + 1 })
      this.handleComplete(this.progressData.progress)
    },
    handleComplete (progress) {
      if (progress < 60) return
      this.handleProgressData({ timer: false, status: 'COMPLETE', progress: 0 })

      if (this.progressData.status === 'COMPLETE') {
        setTimeout(() => {
          this.handleProgressData({ timer: true, status: 'FAKE' })
        }, 2000)
      }
    },
    // 劫持playing函數, 使事件能夠解耦
    hijackPlaying () {
      const parentPlaying = this.playingEvent
      this.$emit('update:playing-event', () => {
        parentPlaying()
        this.handleProgressData({ timer: true, status: 'FAKE' })
      })
    },
    hijackPasue () {
      const parentPause = this.pauseEvent
      this.$emit('update:pause-event', () => {
        parentPause()
        this.handleProgressData({ timer: false, status: 'FAKE', progress: 0 })
      })
    },
    handleProgressData (newValueObj) {
      this.progressData = {
        ...this.progressData,
        ...newValueObj
      }
    }
  }
}
</script>

<style  scoped>
.fake_progress {
  position: absolute;
  top: 25%;
  right: 0;
}

.fake_dialog {
  padding: 24px;
  background: rgba(0, 0, 0, 0.4);
}

.fullscreen {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 6000;
  max-width: 100vw;
  max-height: 100vh;
  border-radius: 0 !important;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.items-center {
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/views/xbb/Fake.vue